(function () {
  var THRESHOLDS = {
    shipping: 4000,
    save5: 7500,
    save10: 10000,
  };

  function formatDollars(cents) {
    var value = Math.max(0, cents) / 100;
    return value % 1 === 0 ? String(Math.round(value)) : value.toFixed(2);
  }

  function getState(subtotalCents) {
    var subtotal = Math.max(0, Number(subtotalCents) || 0);

    if (subtotal >= THRESHOLDS.save10) {
      return {
        message: "You've unlocked 10% off + FREE shipping!",
        progress: 100,
        tier: 'max',
        unlocked: ['shipping', 'save5', 'save10'],
      };
    }

    if (subtotal >= THRESHOLDS.save5) {
      return {
        message: 'Spend $' + formatDollars(THRESHOLDS.save10 - subtotal) + ' more to unlock 10% off',
        progress: ((subtotal - THRESHOLDS.save5) / (THRESHOLDS.save10 - THRESHOLDS.save5)) * 100,
        tier: 'save5',
        unlocked: ['shipping', 'save5'],
      };
    }

    if (subtotal >= THRESHOLDS.shipping) {
      return {
        message: 'Spend $' + formatDollars(THRESHOLDS.save5 - subtotal) + ' more to unlock 5% off',
        progress: ((subtotal - THRESHOLDS.shipping) / (THRESHOLDS.save5 - THRESHOLDS.shipping)) * 100,
        tier: 'shipping',
        unlocked: ['shipping'],
      };
    }

    return {
      message: 'Spend $' + formatDollars(THRESHOLDS.shipping - subtotal) + ' more for FREE shipping',
      progress: (subtotal / THRESHOLDS.shipping) * 100,
      tier: 'none',
      unlocked: [],
    };
  }

  function paint(root, subtotalCents) {
    if (!root || root.dataset.sipitSpendStatic === 'true') return;

    var state = getState(subtotalCents);
    root.dataset.subtotalCents = String(subtotalCents);

    var messageEl = root.querySelector('[data-sipit-spend-message]');
    var fillEl = root.querySelector('[data-sipit-spend-fill]');
    var barEl = root.querySelector('[data-sipit-spend-bar]');

    if (messageEl) messageEl.textContent = state.message;
    if (fillEl) fillEl.style.width = Math.min(100, Math.max(0, state.progress)) + '%';
    if (barEl) {
      barEl.setAttribute('aria-valuenow', String(Math.round(state.progress)));
      barEl.setAttribute('aria-valuetext', state.message);
    }

    root.querySelectorAll('[data-sipit-spend-milestone]').forEach(function (item) {
      var key = item.getAttribute('data-sipit-spend-milestone') || '';
      var unlocked = state.unlocked.indexOf(key) !== -1 || state.tier === 'max';
      item.classList.toggle('is-unlocked', unlocked);
      item.classList.toggle('is-next', !unlocked && state.tier !== 'max' && isNextTier(state, key));
    });

    root.hidden = subtotalCents <= 0;
  }

  function isNextTier(state, key) {
    if (state.tier === 'none' && key === 'shipping') return true;
    if (state.tier === 'shipping' && key === 'save5') return true;
    if (state.tier === 'save5' && key === 'save10') return true;
    return false;
  }

  function initRoot(root) {
    if (!root || root.dataset.sipitSpendInit === '1') return;
    root.dataset.sipitSpendInit = '1';

    if (root.dataset.sipitSpendStatic === 'true') return;

    var subtotal = Number(root.getAttribute('data-subtotal-cents') || 0);
    paint(root, subtotal);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sipit-spend-tiers]').forEach(initRoot);
  }

  function refreshAll(subtotalCents) {
    if (typeof subtotalCents === 'number' && !Number.isNaN(subtotalCents)) {
      document.querySelectorAll('[data-sipit-spend-tiers]').forEach(function (root) {
        if (root.dataset.sipitSpendStatic === 'true') return;
        paint(root, subtotalCents);
      });
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var subtotal = Number(cart.items_subtotal_price || 0);
        document.querySelectorAll('[data-sipit-spend-tiers]').forEach(function (root) {
          if (root.dataset.sipitSpendStatic === 'true') return;
          paint(root, subtotal);
        });
      })
      .catch(function () {});
  }

  window.SipitSpendTiers = {
    getState: getState,
    refreshAll: refreshAll,
    initAll: initAll,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:cart:lines-update', function () {
    window.setTimeout(refreshAll, 60);
  });

  document.addEventListener('shopify:section:load', function () {
    initAll();
    refreshAll();
  });

  var drawer = document.getElementById('cart-drawer');
  if (drawer && typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function () {
      initAll(drawer);
      refreshAll();
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }
})();
